export const LANG_ES_DICTIONARY = {
  LANG_EN: 'Inglés',
  LANG_ES: 'Español',
  LANG_PT: 'Portugués',
  ALERTA_SUCESSO: 'Éxito',
  ALERTA_ERRO: 'Error',
  ALERTA_ATENCAO: 'Atención',
  ALERTA_INFORMACAO: 'Información',
  ALERTA_QUESTAO: '¿Confirmar?',
  BOTAO_SIM: 'Sí',
  BOTAO_NAO: 'No',
  LABEL_EMPRESA: 'Empresas',
  LABEL_PERIODO: 'Período',
  LABEL_PERIODO_HOJE: 'Hoy',
  LABEL_PERIODO_ONTEM: 'Ayer',
  LABEL_PERIODO_SETE: 'Últimos 7 Días',
  LABEL_PERIODO_TRINTA: 'Últimos 30 Días',
  LABEL_PERIODO_ATUAL: 'Mes Actual',
  LABEL_PERIODO_ANTERIOR: 'Mes Anterior',
  LABEL_FILTROS: 'Filtros',
  MENU_STATUS: 'Estado',
  TOAST_SUCESSO: 'Éxito',
  TOAST_ERRO: 'Error',
  TOAST_ATENCAO: 'Atención',
  TOAST_INFORMACAO: 'Información',
} as const;
